import { render, staticRenderFns } from "./ride-card.vue?vue&type=template&id=2f270688&scoped=true&lang=pug&"
import script from "./ride-card.vue?vue&type=script&lang=js&"
export * from "./ride-card.vue?vue&type=script&lang=js&"
import style0 from "./ride-card.vue?vue&type=style&index=0&id=2f270688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f270688",
  null
  
)

export default component.exports